import moment from 'moment'
/* Format Date "DD/MM/YYYY" */
export default (date) => {
    return moment(date).format('DD/MM/YYYY');
}


// WEBPACK FOOTER //
// ./src/filters/formatDate.js